module.exports = __webpack_public_path__ + "static/wisata-rohani-israel-15c81c7f250dd59799bb8c3add6501ed.png";